import {PureAbility} from '@casl/ability';
import React, {ReactNode, createContext} from 'react';
import {useSelector} from 'react-redux';
import selectUserAbility, {AbilitySentence} from '~/redux/access-control/selectUserAbility';

export type AppAbility = PureAbility<AbilitySentence>;

export const AppAbilityContext = createContext<AppAbility>(new PureAbility<AbilitySentence>());

export default function AbilityContainer({children}: {children?: ReactNode}) {
    const ability = useSelector(selectUserAbility);
    return <AppAbilityContext.Provider value={ability}>{children}</AppAbilityContext.Provider>;
}
